"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _loader = _interopRequireDefault(require("./loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
   liveSaver props:
        * value => current value of field
        * change => function for changing field value by key (used for resetField action), currently from redux-form
        * handleLiveSubmit => function for handling save request, incoming args:
            - key => field key
            - responseCallback => callBack for request response (handleResponse function)
        * loader => field loader component
        * autoSave => boolean for saving field without confirming action on isDirty flag (blur, enter, button click)
        * enterDisabled => boolean for removing submit on enter key (textarea for example)
*/
var LiveSaver = function LiveSaver(props) {
  var _props$liveSaver = props.liveSaver,
      fieldKey = _props$liveSaver.fieldKey,
      initValue = _props$liveSaver.initValue,
      value = _props$liveSaver.value,
      change = _props$liveSaver.change,
      handleLiveSubmit = _props$liveSaver.handleLiveSubmit,
      autoSave = _props$liveSaver.autoSave,
      enterDisabled = _props$liveSaver.enterDisabled,
      active = _props$liveSaver.active,
      label = _props$liveSaver.label,
      children = props.children,
      _props$blurAction = props.blurAction,
      blurAction = _props$blurAction === void 0 ? true : _props$blurAction;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDirty = _useState4[0],
      setIsDirty = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAlert = _useState6[0],
      setIsAlert = _useState6[1];

  var _useState7 = (0, _react.useState)(initValue),
      _useState8 = _slicedToArray(_useState7, 2),
      initialValue = _useState8[0],
      setInitialValue = _useState8[1];

  var liveRef = (0, _react.useRef)(null);
  var classButtons = "live-saver-buttons ".concat(!label ? 'top' : '', " ").concat(isDirty || isAlert ? 'active' : '');

  var handleResponse = function handleResponse(success) {
    // update initial value if response succeeded
    if (success) {
      setInitialValue(value);
      setIsDirty(false);
    }

    setIsLoading(false);
  };

  var submitField = function submitField(forceSubmit) {
    if (checkExactly(value, initialValue)) return;

    if (isDirty || forceSubmit) {
      setIsLoading(true);
      handleLiveSubmit(fieldKey, handleResponse);
    }
  };

  var resetField = function resetField() {
    setIsDirty(false);
    setIsAlert(false);
    change([fieldKey], initialValue);
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (e.keyCode === 13 && !enterDisabled) {
      submitField(); // ENTER
    }

    if (e.keyCode === 27) resetField(); // ESCAPE
  };

  var handleBlur = function handleBlur(e) {
    if (!blurAction) return;
    if (e.relatedTarget && e.relatedTarget.className.indexOf(fieldKey) !== -1) return;
    if (e.relatedTarget && e.relatedTarget.parentElement && e.relatedTarget.parentElement.classList[0] === 'live-saver-buttons') return;
    if (e.target && e.target.parentElement && e.target.previousElementSibling && e.target.parentElement.classList[0] === 'live-saver-buttons') return;
    submitField(true);
  };

  var checkExactly = function checkExactly(val1, val2) {
    return (0, _lodash.isObject)(val1) && (0, _lodash.isObject)(val2) ? val1.value === val2.value : (0, _lodash.isEqual)(val1, val2);
  };

  (0, _react.useEffect)(function () {
    if (value === '' && initialValue === null) return setIsDirty(false);
    return setIsDirty(!checkExactly(initialValue, value));
  }, [value]);
  (0, _react.useEffect)(function () {
    // handle FileInput, Rank and Radio autosave without buttons
    if (isDirty && autoSave) {
      setIsDirty(false);
      submitField(true);
    }
  }, [isDirty, autoSave]);
  (0, _react.useEffect)(function () {
    if (!checkExactly(initialValue, initValue)) {
      if (!checkExactly(initialValue, value)) {
        if (active === fieldKey) {
          setIsDirty(false); // setIsAlert(true);
        } else {
          setIsAlert(false);
          setIsLoading(true);
          change([fieldKey], initValue);
          setTimeout(function () {
            return setIsLoading(false);
          }, 400);
        }
      } else {
        setIsDirty(false);
        setIsAlert(false);
      }

      setInitialValue(initValue);
    }
  }, [initValue]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "live-saver",
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    key: "".concat(fieldKey, "_saver"),
    ref: liveRef
  }, isLoading && /*#__PURE__*/_react["default"].createElement(_loader["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: classButtons
  }, isDirty && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn-save ".concat(fieldKey),
    onClick: submitField
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-check"
  })), isAlert && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn-save red ".concat(fieldKey),
    title: "New value have come"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-info"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn-save ".concat(fieldKey, " reset"),
    onClick: resetField
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-times"
  }))), children);
};

var _default = LiveSaver;
exports["default"] = _default;